import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { subDays } from "date-fns";
import {
  RECONCILIATION_STATUS,
  TGetBankReconcileTransactionFilters,
} from "src/pages/PaymentsV2/types/bankReconciliationTypes/bankReconcileTransactions";
import { fDate } from "src/utils/formatTime";

type BankReconciliationDefaultQueryState = {
  query: TGetBankReconcileTransactionFilters;
  enable: boolean;
};

const emptyQuery: TGetBankReconcileTransactionFilters = {
  accountId: "",
  startDate: "",
  endDate: "",
  status: RECONCILIATION_STATUS.Pending,
  transactionReference: "",
};

const initialState: BankReconciliationDefaultQueryState = {
  query: {
    ...emptyQuery,
    startDate: fDate(subDays(new Date(), 29), "yyyy-MM-dd"),
    endDate: fDate(new Date(), "yyyy-MM-dd"),
  },
  enable: false,
};

const slice = createSlice({
  name: "bankReconciliationDefaultQuery",
  initialState,
  reducers: {
    setBankReconciliationDefaultQueryAction(
      state,
      action: PayloadAction<TGetBankReconcileTransactionFilters>,
    ) {
      state.query = action.payload;
    },
    toggleBankReconciliationDefaultQueryAction(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.enable = action.payload;
      if (!action.payload) {
        state.query = { ...emptyQuery };
      }
    },
  },
});

export default slice.reducer;

export const {
  setBankReconciliationDefaultQueryAction,
  toggleBankReconciliationDefaultQueryAction,
} = slice.actions;

export function setBankReconciliationDefaultQuery(
  query: TGetBankReconcileTransactionFilters,
) {
  return (dispatch) => {
    dispatch(setBankReconciliationDefaultQueryAction(query));
  };
}

export function toggleBankReconciliationDefaultQuery(enable: boolean) {
  return (dispatch) => {
    dispatch(toggleBankReconciliationDefaultQueryAction(enable));
  };
}
